export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 19.25a7.25 7.25 0 100-14.5c-2.509 0-4.68 1.274-5.973 3.22a.75.75 0 01-1.25-.83C6.335 4.8 8.962 3.25 12 3.25A8.75 8.75 0 113.25 12a.75.75 0 011.5 0A7.25 7.25 0 0012 19.25z\" fill=\"#6F7488\"/><path d=\"M5.25 4.75v3h3l-3-3z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.963 4.057a.75.75 0 01.817.163l3 3a.75.75 0 01-.53 1.28h-3a.75.75 0 01-.75-.75v-3a.75.75 0 01.463-.693zM6 6.561V7h.44L6 6.56z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};